export default defineAppConfig({
  myTheme: {
    name: 'Website',
  },
  locales: ['vi', 'en'],
  ui: {
    notifications: {
      // Show toasts at the top right of the screen
      position: 'top-20 bottom-[unset]',
    },
  },
})

declare module '@nuxt/schema' {
  interface AppConfigInput {
    myTheme?: {
      /** Project name */
      name?: string
    }
  }
}
